<template>
  <div>
    <TransitionRoot as="template" :show="open">
      <Dialog
        as="div"
        class="fixed z-10 inset-0 overflow-y-auto"
        @close="close"
      >
        <div
          class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="ease-in duration-200"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <DialogOverlay
              class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span
            class="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
            >&#8203;</span
          >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6"
            >
              <div class="sm:flex sm:items-start">
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <div class="mt-2 text-gray-600">
                    <div class="provoznirad__modal">
                      <div class="pt-8 pb-10 text-xs md:text-sm px-6">
                        <h1 class="text-3xl">Provozní řád</h1>
                        <p class="pt-4">
                          Chatu předávejte v takovém stavu, v jakém jste ji
                          přebírali (odmražená lednička, svlečené povlečení,
                          zametená podlaha, vyčištněné ohniště, gril a rošt na
                          grilování)
                        </p>

                        <p class="pt-4">
                          Všechno vybavení chaty je určeno k Vašemu užívání.
                        </p>

                        <p class="pt-4">
                          Žádáme ubytované, aby používali v chatě domácí obuv.
                        </p>

                        <p class="pt-4">
                          Zákaz používání vlastních elektrospotřebíčů.
                        </p>

                        <p class="pt-4">V celém objektu zákaz kouření.</p>

                        <p class="pt-4">
                          Z důvodu vlhkého ovzudší (lázeňské klima a v blízkosti
                          potok) prosíme o časté větrání objektu.
                        </p>

                        <p class="pt-4">
                          Používání dětského kouktu na vlastní nebezpečí.
                        </p>

                        <p class="pt-4">
                          Odpad ukládejte do igelitových sáčků, PET lahve
                          (rozdupávejte) a odhazujte do plastového pytle, popel
                          z ohniště dávejte na hráz potoka.
                        </p>

                        <p class="pt-4">
                          Vzniklé škody nahlaste k opravě neprodleně nebo při
                          odjezdu.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                  @click="close"
                  ref="cancelButtonRef"
                >
                  Zavřít
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script>
import { computed } from "vue";
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { ExclamationIcon } from "@heroicons/vue/outline";
import { useStore } from "vuex";

export default {
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    ExclamationIcon,
  },
  setup() {
    const store = useStore();

    return {
      open: computed(() => store.getters.provozniRadOpened),
      close: () => store.commit("CLOSE_MODAL"),
    };
  },
};
</script>

<style>
.provoznirad__modal {
  height: 90vh;
}

@media only screen and (min-width: 40em) {
  .provoznirad__modal {
    height: 38rem;
  }
}
</style>
